<template>
    <div class="all_header">
        <div class="home_containerh5">
            <div class="home_top">
                <div class="t_left">
                    <img src="@/mobile/assets/index/logo.png" alt="" @click="titleClick(0)">
                    <div class="t_title" @click="globalClick">{{$t('h.b2r_10')}}</div>
                </div>
                <div class="t_right">
                    <!-- <img class="search" src="@/mobile/assets/index/search.png" alt="" @click="showSearchPopup"> -->
                    <img class="menu" src="@/mobile/assets/index/menu.png" alt="" @click="showMenuPopup">
                </div>
            </div>
        </div>
        <!-- 右侧弹框菜单 -->
        <van-popup
            v-model="showSidebar"
            position="right"
            :style="{ width: '55%', height: '100%' }"
        >
        <div class="custom-menu">
                <!-- 父菜单循环 -->
                <div 
                    v-for="(item, parentIndex) in menuItems" 
                    :key="item.id"
                    class="menu-wrapper"
                >
                    <!-- 父菜单项（点击展开/折叠子菜单） -->
                    <div 
                        class="menu-item"
                        @click="handleParentClick(item,parentIndex)"
                    >
                        <span :class="{'activeTitle':item.id==activeMenu}">{{ item.title }}</span>
                        <!-- 箭头：根据子菜单是否展开切换方向 -->
                        <van-icon 
                            name="arrow" 
                            :style="{ transform: item.expanded ? 'rotate(90deg)' : 'rotate(0)' }" 
                        />
                    </div>

                    <!-- 子菜单（有子项时显示） -->
                    <div 
                        class="submenu-list"
                        v-if="item.children && item.children.length > 0 && item.expanded"
                    >
                        <div 
                            class="submenu-item"
                            v-for="(subItem, subIndex) in item.children" 
                            :key="subIndex"
                            :class="{'active-submenu': isSubmenuActive(item.id, subItem.path)}"
                            @click="handleSubmenuClick(subItem, parentIndex)"
                        >
                            {{ subItem.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="lang_main" @click="changeLangEvent($i18n.locale=='zh'?'en':'zh')">
                <img src="@/mobile/assets/index/lang.png" alt=""></img>
                <div class="lang" >{{ $i18n.locale=='zh'?'EN':'中' }}</div>
            </div>
        </van-popup>

        <van-popup
                v-model="showSearch"
                position="top"
                class="custom-search-popup"
                @open="handlePopupOpen"
            >
            <!--get-container挂载到指定 ID 的容器  如get-container="#custom-container"-->
            <!-- 搜索框：移除默认样式，占满剩余高度 -->
             <div class="search-container">
                <input
                    ref="searchInput"
                    v-model="searchValue"
                    type="search"
                    enterkeyhint="go"
                    @keyup.enter="onSearch"
                    placeholder="请输入型号/产品信息"
                    class="custom-search"
                />
                <div class="searchBtn" @click="onSearch">
                    <img src="@/mobile/assets/index/searchBtn.png" alt="">
                </div>
             </div>
        </van-popup>
    </div>
</template>
<script>
export default{
    data() {
        return{
            searchValue: '',
            showSearch:false,
            hoverIndex:'-1',
            showItems:false,
            showItemsBrand:false,
            showItemsQuality:false,
            showItemsAppli:false,
            activeIndex: "",

            showSidebar: false,
            activeMenu: 1,
            // 添加 activeSubMenu 来记录当前选中的子菜单路径
            activeSubMenu: '',
            menuItems: [
                { 
                    id: 1, 
                    title: this.$t("h.home"), 
                    path: 'home',
                    children: [], // 无子女菜单
                    expanded: false 
                },
                { 
                    id: 2, 
                    title: this.$t("h.aboutus"), 
                    children: [ // 子菜单列表
                        { title: this.$t("h.fl1_1"), path: 'aboutus' },
                        { title: this.$t("h.aboutabracon"), path: 'aboutabracon' },
                        { title: this.$t("h.fl1_2"), path: 'joinus' }
                    ],
                    expanded: false // 初始折叠
                },
                { 
                    id: 3, 
                    title: this.$t('h.linecard'), 
                    children: [
                        { title: 'Top 50 Lines', path: 'linecard' },
                        { title: this.$t("h.fl2_2"), path: 'putBrand' }
                    ],
                    expanded: false
                },
                { 
                    id: 4, 
                    title: this.$t("h.qualitycontrol"), 
                    children: [
                        { title: this.$t("h.fl3_1"), path: 'vdetails' },
                        { title: this.$t("h.fl3_2"), path: 'cdetails' },
                        { title: this.$t("h.fl3_3"), path: 'qdetails' },
                        { title: this.$t("h.fl3_4"), path: 'wdetails' }
                    ],
                    expanded: false
                },
                { 
                    id: 5, 
                    title: this.$t('h.contactus'), 
                    path: 'contactus',
                    children: [],
                    expanded: false
                },
            ]
            // 菜单数据：添加children子项和expanded状态（控制展开/折叠）
            
        }
    },
    created() {
        if(this.$route.meta.currentIndex) {
            this.activeIndex = this.$route.meta.currentIndex
        } else {
            this.activeIndex = parseInt(localStorage.getItem('activeIndex')) || 0
        }
        // 根据当前路由路径设置激活的菜单项
        this.setActiveMenuByRoute();
    },
    computed: {
        // this.$t("h.applications"),
    },
    methods:{
        handlePopupOpen() {
            this.$nextTick(() => {
                this.focusNativeInput();
            });
        },
        
        focusNativeInput() {
            if (this.$refs.searchInput) {
                const input = this.$refs.searchInput;
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);

                const isWechat = /MicroMessenger/i.test(navigator.userAgent);
                if (isWechat) {
                const fakeClick = document.createElement('div');
                fakeClick.style.cssText = 'width:1px;height:1px;position:absolute;top:-100px;';
                document.body.appendChild(fakeClick);
                fakeClick.click();
                document.body.removeChild(fakeClick);
                setTimeout(() => {
                    input.focus();
                }, 50);
                }
            }
        },
        
        onSearch() {
            console.log('搜索:', this.searchValue);
            // 你的搜索逻辑
        },
        showSearchPopup() {
            this.showSearch = true
        },  
         // 判断子菜单是否激活
        isSubmenuActive(parentId, subPath) {
            // 如果当前父菜单是激活的，并且子菜单路径匹配
            if (parentId === this.activeMenu) {
                // 如果有 activeSubMenu，则使用它进行精确匹配
                if (this.activeSubMenu) {
                    return subPath === this.activeSubMenu;
                }
                // 如果没有 activeSubMenu，检查当前路由是否匹配
                return subPath === this.$route.name;
            }
            return false;
        },
        // 新增方法：根据当前路由设置激活的菜单
        setActiveMenuByRoute() {
            const currentRouteName = this.$route.name;
            const currentRoutePath = this.$route.path;
            
            // 遍历所有菜单项
            for (let i = 0; i < this.menuItems.length; i++) {
                const menuItem = this.menuItems[i];
                
                // 检查父菜单路径是否匹配
                if (menuItem.path === currentRouteName) {
                    this.activeMenu = menuItem.id;
                    this.activeSubMenu = '';
                    menuItem.expanded = true;
                    break;
                }
                
                // 检查子菜单路径是否匹配
                if (menuItem.children && menuItem.children.length > 0) {
                    const matchedChild = menuItem.children.find(child => 
                        child.path === currentRouteName
                    );
                    
                    if (matchedChild) {
                        this.activeMenu = menuItem.id;
                        this.activeSubMenu = matchedChild.path;
                        menuItem.expanded = true;
                        break;
                    }
                }
            }
        },
        // 修改：点击父菜单时也需要更新状态
        handleParentClick(row, parentIndex) {
            this.activeMenu = row.id;
            this.activeSubMenu = ''; // 点击父菜单时清空子菜单选中
            
            const item = this.menuItems[parentIndex];
            
            // 如果有子菜单才切换展开状态，无子菜单直接跳转
            if (item.children && item.children.length > 0) {
                // 如果点击的是当前已激活的父菜单，则切换展开状态
                // 如果点击的是其他菜单，则展开并收起其他菜单
                this.menuItems.forEach((menu, index) => {
                    if (index === parentIndex) {
                        menu.expanded = !menu.expanded;
                    } else {
                        menu.expanded = false;
                    }
                });
            } else {
                this.$router.push({ name: item.path });
                // 保存到 localStorage
                localStorage.setItem('activeMenu', this.activeMenu);
                localStorage.setItem('activeSubMenu', '');
                this.showSidebar = false;
            }
        },
        
        // 修改：点击子菜单时保存状态
        handleSubmenuClick(subItem, parentIndex) {
            this.activeMenu = this.menuItems[parentIndex].id;
            this.activeSubMenu = subItem.path;
            
            this.$router.push({ name: subItem.path });
            
            // 保存到 localStorage
            localStorage.setItem('activeMenu', this.activeMenu);
            localStorage.setItem('activeSubMenu', this.activeSubMenu);
            
            // 关闭当前父菜单的展开状态（可选，根据需求）
            // this.menuItems[parentIndex].expanded = false;
            
            // 关闭侧边栏
            this.showSidebar = false;
        },
        
        // 新增：显示侧边栏时恢复状态
        showMenuPopup() {
            // 从 localStorage 恢复状态
            const savedMenu = localStorage.getItem('activeMenu');
            const savedSubMenu = localStorage.getItem('activeSubMenu');
            
            if (savedMenu) {
                this.activeMenu = parseInt(savedMenu);
                this.activeSubMenu = savedSubMenu || '';
                
                // 设置对应的菜单展开状态
                this.menuItems.forEach(menu => {
                    if (menu.id === this.activeMenu) {
                        menu.expanded = true;
                    } else {
                        menu.expanded = false;
                    }
                });
            }
            
            this.showSidebar = true;
        },
        switchLanguage() {
            // 语言切换逻辑
            this.$dialog.confirm({
                title: '切换语言',
                message: '确定要切换到英文吗？',
            }).then(() => {
                this.$toast('已切换到英文')
                // 这里可以添加实际的语言切换逻辑
            }).catch(() => {
                // 取消操作
            })
        },
        showMenuPopup() {
            this.showSidebar = true
        },
        globalClick() {
            this.$router.push({name:'GTCS'})
        },
        mouseenter(index) {
            this.hoverIndex = index
            if(index==1) {
                this.showItems = true
            } else if (index==2) {
                this.showItemsBrand = true
            } else if (index==3){
                this.showItemsQuality = true
            } 
            // else if (index==4){
            //     this.showItemsAppli = true
            // }
        },
        mouseleave() {
            this.hoverIndex = '-1'
            this.showItems = false
            this.showItemsBrand = false
            this.showItemsQuality = false
            this.showItemsAppli = false
        },
        changeLangEvent(val){
            if (val == "zh"){
                localStorage.setItem("locale", "zh");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "ZH");
                location.reload(); //重新加载
            } else if (val == "en"){
                localStorage.setItem("locale", "en");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "EN");
                location.reload();
            }
        },
        titleClick(index) {
            this.activeIndex = index
            if(index==0) {
                this.$router.push({name:'home'})
            } else if(index==1) {
                this.$router.push({name:'aboutus'})
            } else if(index==2) {
                this.$router.push({name:'linecard'})
            } else if(index==3) {
                // this.$router.push({name:'qualitycontrol'})
                this.$router.push({name:'vdetails'})
            } 
            // else if(index==4) {
            //     this.$router.push({name:'applications'})
            // } 
            else if(index==4) {
                this.$router.push({name:'contactus'})
            }
            localStorage.setItem('activeIndex', index);
        },
        clickputBrand() {
            this.activeIndex = 2
            localStorage.setItem('activeIndex', 2);
            this.showItemsBrand = false
            this.$router.push({name:'putBrand',query: { tip: '2'}})
        },
        clickapplications(val) {
            this.activeIndex = 4
            localStorage.setItem('activeIndex', 4);
            this.showItemsAppli = false
            this.$router.push({name:'applications',query: { title: val}})
        },
        clickV() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'vdetails'})
        },
        clickC() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'cdetails'})
        },
        clickQ() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'qdetails'})
        },
        clickW() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'wdetails'})
        },
        clicklinkcard() {
            this.activeIndex = 2
            localStorage.setItem('activeIndex', 2);
            this.showItemsBrand = false
            this.$router.push({name:'linecard',query: { tip: '1'}})
            window.location.reload();
        },
        clickaboutus() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'aboutus',query: { aboutus: '1'}})
            window.location.reload();
        },
        clickaboutabracon() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'aboutabracon'})
        },
        clickjoinus() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'joinus'})
        },
    }
}
</script>
<style lang="scss" scoped>
::v-deep .custom-search-popup {
    top: 60px !important;
    width: calc(100% - 152px) !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    background: transparent !important;
    border: none !important;
}
.search-container{
    display: flex;
    align-items: center; /* 添加垂直居中 */
    justify-content: center;
}
.custom-search  {
  /* 搜索内容区域 */
    background: #fff;
    border-radius: 5px;
    width: 520px;
    height: 80px;
    line-height: 80px;
    background: #FFFFFF;
    border-radius: 5px 0 0 5px;
    display: flex;
    align-items: center; /* 添加垂直居中 */
    padding-left: 20px;
}
.custom-search::placeholder {
    font-weight: 400;
    font-size: 22px;
    color: #999999;
}
.searchBtn{
    width: 80px;
    height: 80px;
    background: #12407A;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 5px 5px 0;
    img{
        width: 30px;
        height: 30px;
    }
}
.custom-menu{
    padding-top: 50px;
    // 父菜单容器
    .menu-wrapper {
        margin-bottom: 10px; // 父菜单之间的间距
    }
    // 父菜单项样式
    .menu-item{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 50px;
        margin: 0 30px 0 50px;
        span {
            font-weight: 400;
            font-size: 24px;
            color: #333333;
        }
        .activeTitle{
            color: #12407A;
        }
        // 箭头图标样式
        .van-icon {
            transition: transform 0.3s ease; // 箭头旋转动画
            color: #999;
        }
    }

    // 子菜单列表容器
    .submenu-list{
        padding-left: 50px; // 左缩进，与父菜单错开
        overflow: hidden;
        transition: max-height 0.3s ease; // 展开/折叠动画
    }

    // 子菜单项样式
    .submenu-item{
        font-weight: 400;
        font-size: 22px;
        color: #666666;
        padding-bottom: 50px;
        // &:hover {
        //     color: #12407A; // hover时变色
        // }
    }
    .active-submenu{
        color: #12407A;
    }
}
.lang_main{
    display: flex;
    align-items: center;
    border-top: 1px solid #EEEEEE;
    padding: 50px 0 0 0;
    margin: 0 30px 0 50px;
    .lang{
        font-weight: 400;
        font-size: 22px;
        color: #333333;
    }
    img{
        width: 26px;
        height: 26px;
        margin-right: 10px;
    }
}
.all_header{
    top: 0px;
    background: rgb(255, 255, 255);
    position: fixed; // 改为固定定位
    z-index: 1000; // 增加 z-index 确保在最上层
    width: 100%;
    // 可以添加阴影效果，让头部有层次感
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    .home_containerh5{
        
        .home_top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 25px;
            height: 80px;
            .t_left{
                display: flex;
                align-items: center;
                img {
                    width: 175px;
                    height:58px;
                    position: relative;
                    top: 5px;
                }
                .t_title{
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 22px;
                    color: #333333;
                    margin-left: 40px;
                }
            }
            .t_right{
                display: flex;
                align-items: center;
                .search{
                    width: 30px;
                    height:30px;
                    cursor: pointer;
                }
                .menu{
                    width: 31px;
                    height:30px;
                    cursor: pointer;
                    margin-left: 40px;
                }
            }
        }
    }

}

</style>